// 业务转凭证 API
import Ajax from '../js/common/ajax';

export default {
  /**
   * 上传Excel并解析
   * @param {FormData} formData - 包含文件的表单数据
   * @param {string} platform - 平台
   * @param {string} businessType - 业务类型：shop_payment(店铺营收) 或 inventory(进销存)
   * @param {string} storeCode - 店铺编码
   * @param {string} storeName - 店铺名称
   * @param {string} businessDate - 业务日期
   */
  uploadBusinessVoucher(formData, platform, businessType, storeCode, storeName, businessDate) {
    return Ajax.post('/business-voucher/upload', formData, {
      params: { platform, businessType, storeCode, storeName, businessDate },
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  /**
   * 预览凭证
   */
  previewVouchers(taskId) {
    return Ajax.get(`/business-voucher/preview/${taskId}`);
  },

  /**
   * 生成凭证
   */
  generateVouchers(taskId) {
    return Ajax.post(`/business-voucher/generate/${taskId}`);
  },

  /**
   * 查询任务列表
   */
  listTasks(params) {
    return Ajax.get('/business-voucher/tasks', params);
  },

  /**
   * 查询任务详情
   */
  getTaskDetail(taskId) {
    return Ajax.get(`/business-voucher/task/${taskId}`);
  },

  /**
   * 查询证据链
   * @param {Object} params
   * @param {string|number} params.voucherId
   * @param {string} params.traceId
   */
  getEvidenceChain(params = {}) {
    if (params.voucherId) {
      return this.getEvidenceChainByVoucherId(params.voucherId);
    }
    if (params.traceId) {
      return this.getEvidenceChainByTraceId(params.traceId);
    }
    return Promise.resolve({
      code: 500,
      msg: 'voucherId 或 traceId 不能为空'
    });
  },

  /**
   * 按凭证ID查询证据链
   */
  getEvidenceChainByVoucherId(voucherId) {
    return Ajax.get(`/accounting/evidence-chain/voucher/${encodeURIComponent(voucherId)}`);
  },

  /**
   * 按 traceId 查询证据链
   */
  getEvidenceChainByTraceId(traceId) {
    return Ajax.get(`/accounting/evidence-chain/trace/${encodeURIComponent(traceId)}`);
  },

  /**
   * 查询 POST_FAILED 最小样本
   */
  getFailedEvidenceSamples(params = {}) {
    return Ajax.get('/accounting/evidence-chain/failed', params);
  },

  /**
   * 删除任务
   */
  deleteTask(taskId) {
    return Ajax.delete(`/business-voucher/task/${taskId}`);
  },

  /**
   * 查询业务场景配置
   */
  getBusinessScenarios(platform, accountSetsId) {
    return Ajax.get('/admin/business-scenario/all', {
      platform,
      accountSetsId
    });
  },

  /**
   * 更新业务明细（持久化预览编辑）
   */
  updateDetails(details) {
    return Ajax.put('/business-voucher/update-details', details);
  },

  /**
   * 查询 Decision Memory review-view
   * @param {number} detailId - 业务明细ID
   */
  getMemoryReviewView(detailId) {
    return Ajax.get(`/accounting/decision-memory-review/review-view/${detailId}`);
  },

  /**
   * 提交 Decision Memory review action
   * @param {number} detailId - 业务明细ID
   * @param {Object} payload - review action 请求体
   */
  submitMemoryReviewAction(detailId, payload) {
    return Ajax.post(`/accounting/decision-memory-review/review-action/${detailId}`, payload);
  },
};
